import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AvvisoFormMessage from "../../UI/Form/AvvisoFormMessage";
import { dialogButtonConfirm, dialogForgotPassword } from "../../../const/DialogData";
import { requestResetPassword } from "../../../const/urlAction.js";
import { useTranslation } from "react-i18next";
import { closeDialogUser } from "../../../redux/reducers/dialogUser-reducer";
import useMobileDetection from "../../../Hooks/useMobileDetection";
import handlerError from "../../../functions/handlerError.js";
import { showLoader, hideLoader } from "../../../redux/reducers/appLoader-reducer";
import { notificationOpen } from "../../../redux/reducers/notification-reducer.js";
import { useFormik } from "formik";
import axios from "axios";
import * as Yup from 'yup';

export default function DialogForgotPassword({ isOpen = false, returnIsOpen = () => null }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dialogState = useSelector((state) => state.dialogUser);
  const appLoadingState = useSelector((state) => state.appLoader.loading);
  const isMobile = useMobileDetection();

  const validationSchema = Yup.object({
    email: Yup.string().email(t("validation_email")).required(t("validation_required"))
  });

  const formik = useFormik({
    initialValues: {
      email: ""
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      dispatch(showLoader());

      const payload = {
        email: values.email
      };
      
      try {
        const { action, method } = requestResetPassword;
        const response = await axios({
          method,
          url: process.env.REACT_APP_URL + action,
          data: payload
        });

        dispatch(notificationOpen({ message: response.data.message, status: "success" }));
        closeDialog();
      } catch (error) {
        dispatch(notificationOpen(handlerError(error)));
      }

      dispatch(hideLoader());
    }
  });

  const closeDialog = () => {
    formik.resetForm();
    dispatch(closeDialogUser());
  };

  useEffect(() => {
      returnIsOpen(dialogState.isOpen)
  }, [dialogState])

  return (
    <Dialog
      open={isOpen}
      onClose={closeDialog}
      fullWidth
      fullScreen={isMobile}
      maxWidth={"sm"}
    >
      <DialogTitle>
        {t(dialogForgotPassword.DialogTitle)}
      </DialogTitle>
      
      <DialogContent className="border-Content-dialog">
        <AvvisoFormMessage msg={t("confirmation_email_sent")} />
        <TextField
          fullWidth
          id="email"
          name="email"
          label={t("email")}
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          margin="normal"
          variant="standard"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={closeDialog}>
          {t(dialogButtonConfirm.Cancel)}
        </Button>
        <Button 
          onClick={formik.handleSubmit} 
          variant="contained" 
          disabled={appLoadingState || !formik.isValid || !formik.values.email}
        >
          {t(dialogButtonConfirm.Confirm)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}